// Funciones
import { ROUTES } from "../../../../../const/routes";

/**
 * Assets del fondo del tragamonedas
 * @param {*} scene 
 */
export function cargaAssetsFondo(scene) {
  scene.load.image(
    "fondo",
    ROUTES.rutaTragamonedasFondo + "/fondoResized.png"
  );
}
